<template>
  <div class="acvicity">
    <img class="img" :src="activity_pic1" alt />
    <div class="video-c">
      <video id="myVideo0" class="video-js">
        <source :src="videoUrl" type="video/mp4" />
      </video>
    </div>
    <img class="img" :src="activity_pic2" alt @click="onGetCouponsClick" />
  </div>
</template>

<script>
import API from "./api";
import { Toast } from "mint-ui";
export default {
  beforeRouteLeave(to, from, next) {
    this.video && this.video.dispose();
    next(); //一定不要忘记写
  },
  components: {},
  data() {
    return {
      video: null,
      activity_pic1: "",
      activity_pic2: "",
      videoUrl: ""
    };
  },
  methods: {
    get_pic_imgs() {
      API.get_pic(
        {
          type: 4
        },
        res => {
         
          if (res && res.code) {
            this.activity_pic1 = res.data.activity_pic1;
            this.activity_pic2 = res.data.activity_pic2;
          }
        }
      );
    },
    get_pic_video() {
      API.get_pic(
        {
          type: 5
        },
        res => {
          if (res && res.code) {
            this.videoUrl = res.data.activity_video;
            this.$nextTick(() => {
              this.initVideo();
            });
          }
        }
      );
    },
    initVideo() {
      //初始化视频方法
      this.video = this.$video("myVideo0", {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: 'muted',
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "7.5rem",
        //设置视频播放器的显示高度（以像素为单位）
        height: "4.2rem"
      });
    },
    onDetailClick() {
      this.$router.push({
        name: "activity-detail",
        params: {}
      });
    },
    onGetCouponsClick() {
      API.activity(
        {
          phone: this.$store.state.phone
        },
        res => {
          if (res.code == 1) {
            this.$router.push({
              name: "coupons",
              params: {}
            });
          } else {
            Toast({
              message: res.msg,
              iconClass: "icon icon-error"
            });
          }
        }
      );
    }
  },
  mounted() {
    this.get_pic_imgs();
    this.get_pic_video();
  }
};
</script>

<style scoped lang="scss">
.acvicity {
  width: 7.5rem;
  .img {
    width: 7.5rem;
  }
  .video-c {
    width: 7.5rem;
    height: 4.2rem;
    .video-js {
      width: 7.5rem;
      height: 4.2rem;
      /deep/.vjs-big-play-button {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
